/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// React Router
import { Link } from 'react-router-dom';

const Item = ({ data }) => {
    return (
        <div className="flex items-center">
            <div>
                <img src={data.icon} className="select-none" alt="Icon" />
            </div>
            <div className="ml-5">
                {data.linkType === 'route' ?
                    <Link to={data.link}>
                        <h1 className="text-lg text-gray-300 font-semibold">{data.name}</h1>
                        <p className="text-gray-300">{data.description}</p>
                    </Link>
                :
                    <a href={data.link}>
                        <h1 className="text-lg text-gray-300 font-semibold">{data.name}</h1>
                        <p className="text-gray-300">{data.description}</p>
                    </a>
                }
            </div>
        </div>
    )
}

export default Item